import { render, staticRenderFns } from "./fonts.vue?vue&type=template&id=5ce8b77e&scoped=true&"
import script from "./fonts.vue?vue&type=script&lang=js&"
export * from "./fonts.vue?vue&type=script&lang=js&"
import style0 from "./fonts.vue?vue&type=style&index=0&id=5ce8b77e&lang=scss&scoped=true&"
import style1 from "./fonts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8b77e",
  null
  
)

export default component.exports